import styled from 'styled-components';
import { Row as RawRow } from 'components/shared/Layout';
import FormattedCurrency from 'components/ui/FormattedCurrency';

import { colours } from 'themes/default';

export const BoldFormattedCurrency = styled(FormattedCurrency)`
  font-weight: bold;
`;

BoldFormattedCurrency.displayName = 'BoldFormattedCurrency';

export const BorderedRow = styled(RawRow)`
  border-top: 1px solid grey;
  border-bottom: 1px solid grey;
  font-weight: 600;
`;

BorderedRow.displayName = 'BorderedRow';

export const Row = styled(RawRow)`
  p {
    margin: 0;
  }
`;

export const StyledAmount = styled.p`
  text-align: left;
`;

export const Toggle = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${colours.Greyscale.White};
  cursor: pointer;
  display: flex;
  justify-content: center;
  transform: rotate3d(0, 0, ${({ isActive }) => (isActive ? '1' : '0')}, 180deg);
  transition: transform 0.15s ease-in-out;
`;
